import { useState } from "react";

/* ── Exercise metadata ── */
const exMeta = {
  // — Upper Machines —
  "Chest Press Machine":        { icon: "⚙️", muscles: ["Chest","Triceps"] },
  "Incline Chest Press Machine":{ icon: "⚙️", muscles: ["Upper Chest","Triceps"] },
  "Seated Row Machine":         { icon: "⚙️", muscles: ["Mid Back","Biceps"] },
  "Lat Pulldown Machine":       { icon: "⚙️", muscles: ["Lats","Biceps"] },
  "Shoulder Press Machine":     { icon: "⚙️", muscles: ["Shoulders","Triceps"] },
  "Pec Deck / Chest Fly":      { icon: "⚙️", muscles: ["Chest","Front Delts"] },
  "Reverse Fly Machine":        { icon: "⚙️", muscles: ["Rear Delts","Rhomboids"] },
  "Tricep Pushdown (Cable)":    { icon: "🔗", muscles: ["Triceps"] },
  "Cable Bicep Curl":           { icon: "🔗", muscles: ["Biceps"] },
  "Lateral Raise Machine":      { icon: "⚙️", muscles: ["Shoulders"] },
  "Assisted Pull-Up Machine":   { icon: "⚙️", muscles: ["Lats","Biceps","Core"] },
  "Cable Face Pulls":           { icon: "🔗", muscles: ["Rear Delts","Rotator Cuff"] },
  // — Lower Machines —
  "Leg Press Machine":          { icon: "⚙️", muscles: ["Quads","Glutes"] },
  "Hack Squat Machine":         { icon: "⚙️", muscles: ["Quads","Glutes"] },
  "Leg Extension Machine":      { icon: "⚙️", muscles: ["Quads"] },
  "Seated Leg Curl Machine":    { icon: "⚙️", muscles: ["Hamstrings"] },
  "Lying Leg Curl Machine":     { icon: "⚙️", muscles: ["Hamstrings"] },
  "Hip Thrust Machine":         { icon: "⚙️", muscles: ["Glutes","Hams"] },
  "Hip Abduction Machine":      { icon: "⚙️", muscles: ["Glute Med","Abductors"] },
  "Hip Adduction Machine":      { icon: "⚙️", muscles: ["Adductors"] },
  "Calf Raise Machine":         { icon: "⚙️", muscles: ["Calves"] },
  "Smith Machine Squat":        { icon: "⚙️", muscles: ["Quads","Glutes","Core"] },
  "Pendulum Squat Machine":     { icon: "⚙️", muscles: ["Quads","Glutes"] },
  "Belt Squat Machine":         { icon: "⚙️", muscles: ["Quads","Glutes"] },
  // — Hyrox Exercises —
  "SkiErg":                     { icon: "🎿", muscles: ["Lats","Triceps","Core","Cardio"] },
  "Sled Push":                  { icon: "🛷", muscles: ["Quads","Glutes","Core","Cardio"] },
  "Sled Pull":                  { icon: "🛷", muscles: ["Back","Biceps","Hams","Cardio"] },
  "Burpee Broad Jumps":         { icon: "⚡", muscles: ["Full Body","Cardio"] },
  "Rowing (1 min sprint)":      { icon: "🚣", muscles: ["Back","Legs","Cardio"] },
  "Farmers Carry":              { icon: "🏋️", muscles: ["Grip","Traps","Core","Cardio"] },
  "Sandbag Lunges":             { icon: "🏋️", muscles: ["Quads","Glutes","Core","Cardio"] },
  "Wall Balls":                 { icon: "🎯", muscles: ["Quads","Shoulders","Cardio"] },
  "Box Jump Overs":             { icon: "📦", muscles: ["Quads","Glutes","Calves","Cardio"] },
  "Kettlebell Swings":          { icon: "🏋️", muscles: ["Glutes","Hams","Core","Cardio"] },
  "Battle Ropes":               { icon: "🔗", muscles: ["Shoulders","Core","Cardio"] },
  "Assault Bike (1 min sprint)":{ icon: "🚴", muscles: ["Quads","Hams","Cardio"] },
  "Dead Ball Slams":            { icon: "💥", muscles: ["Full Body","Cardio"] },
  "Bear Crawl":                 { icon: "🐻", muscles: ["Shoulders","Core","Cardio"] },
  "Treadmill Sprint":           { icon: "🏃", muscles: ["Quads","Hams","Cardio"] },
  "Plank Hold":                 { icon: "🎯", muscles: ["Abs","Obliques","Core"] },
  "Mountain Climbers":          { icon: "⚡", muscles: ["Core","Hip Flexors","Cardio"] },
  "Jump Rope":                  { icon: "⚡", muscles: ["Calves","Cardio"] },
  "Med Ball Cleans":            { icon: "🏋️", muscles: ["Full Body","Cardio"] },
  "Thrusters (Dumbbell)":       { icon: "🏋️", muscles: ["Quads","Shoulders","Cardio"] },
  // — Running —
  "Easy Run (Zone 2)":          { icon: "🏃", muscles: ["Legs","Cardio"] },
  "Tempo Run (Zone 3–4)":       { icon: "🏃", muscles: ["Legs","Cardio"] },
  "Interval Sprints":           { icon: "🏃", muscles: ["Quads","Hams","Cardio"] },
  "Hill Repeats":               { icon: "⛰️", muscles: ["Glutes","Calves","Cardio"] },
  "Cool Down Jog":              { icon: "🏃", muscles: ["Legs","Cardio"] },
  "Dynamic Warm-Up":            { icon: "🔥", muscles: ["Full Body"] },
  "Stretching & Cool Down":     { icon: "🧘", muscles: ["Full Body"] },
};
const getMeta = (name) => exMeta[name] || { icon: "💪", muscles: [] };

const tagStyle = (m) => {
  const map = {
    Quads: "#3B82F6", Glutes: "#EC4899", Hamstrings: "#F59E0B", Hams: "#F59E0B",
    Calves: "#10B981", Core: "#8B5CF6", Abs: "#8B5CF6", Obliques: "#A855F7",
    "Hip Flexors": "#F97316", Adductors: "#06B6D4", "Glute Med": "#EC4899",
    Abductors: "#EC4899", Cardio: "#EF4444",
    Chest: "#F43F5E", Triceps: "#F97316", "Front Delts": "#F97316",
    "Upper Chest": "#F43F5E", Shoulders: "#F97316", "Rear Delts": "#06B6D4",
    Rhomboids: "#06B6D4", Lats: "#3B82F6", Biceps: "#F59E0B",
    "Mid Back": "#06B6D4", "Rotator Cuff": "#06B6D4",
    Back: "#3B82F6", Legs: "#EC4899", Grip: "#6366F1", Traps: "#6366F1",
    "Full Body": "#8B5CF6",
  };
  const c = map[m] || "#6366F1";
  return { background: c + "15", color: c, borderColor: c + "30" };
};

/* ── 5 Session Templates: Sun–Thu ── */
const templates = [
  // ─── SUNDAY: Upper Machines + Hyrox ───
  { type: "A", name: "Upper + Hyrox", focus: "Upper body machines 20 min + Hyrox circuit 20 min", emoji: "💪", color: "#E8553A",
    blocks: [
      { label: "UPPER MACHINES", time: "20 min", exercises: [
        { name: "Chest Press Machine", sets: "3", reps: "12", rest: "45s", note: "Adjust seat so handles align with mid-chest. Controlled 2s eccentric, explosive press." },
        { name: "Seated Row Machine", sets: "3", reps: "12", rest: "45s", note: "Squeeze shoulder blades at contraction. Mid-back thickness builder — rhomboids + mid traps." },
        { name: "Shoulder Press Machine", sets: "3", reps: "10", rest: "45s", note: "Press overhead without locking elbows. Anterior + medial deltoids ~72% MVIC." },
        { name: "Lat Pulldown Machine", sets: "3", reps: "12", rest: "45s", note: "Wide grip for lat width. Pull to upper chest, lean back slightly." },
        { name: "Pec Deck / Chest Fly", sets: "2", reps: "12", rest: "30s", note: "Constant tension isolates pecs without tricep fatigue. Great finisher after pressing." },
        { name: "Tricep Pushdown (Cable)", sets: "2", reps: "12", rest: "30s", note: "Keep elbows pinned. Lateral head peaks at ~80% MVIC during cable pushdowns." },
      ]},
      { label: "HYROX CIRCUIT", time: "20 min · 4 rounds × 5 exercises × 1 min", exercises: [
        { name: "SkiErg", sets: "4", reps: "1 min", rest: "0s", note: "Full-body pull. Hinge at hips, drive arms explosively. The Hyrox signature cardio — trains the exact race movement. Go straight into next exercise." },
        { name: "Sled Push", sets: "4", reps: "1 min", rest: "0s", note: "Low body angle, drive through legs. Quads + glutes under constant tension. The most Hyrox-specific strength movement." },
        { name: "Wall Balls", sets: "4", reps: "1 min", rest: "0s", note: "Deep squat, explosive throw to 10ft target. Quads + shoulders under fatigue. Find a rhythm and hold it." },
        { name: "Rowing (1 min sprint)", sets: "4", reps: "1 min", rest: "0s", note: "Damper 5–7. Legs drive first, then lean, then pull. Rate ~28–32 spm. Full-body cardio." },
        { name: "Burpee Broad Jumps", sets: "4", reps: "1 min", rest: "0s", note: "Chest to floor → explode forward max distance. Full-body power under fatigue. Rest 30–60s between rounds if needed." },
      ]},
    ],
  },
  // ─── MONDAY: Lower Machines + Hyrox ───
  { type: "B", name: "Lower + Hyrox", focus: "Lower body machines 20 min + Hyrox circuit 20 min", emoji: "🦵", color: "#7C3AED",
    blocks: [
      { label: "LOWER MACHINES", time: "20 min", exercises: [
        { name: "Leg Press Machine", sets: "3", reps: "12", rest: "45s", note: "Feet shoulder-width, mid-platform. Full depth without lower back lifting off pad." },
        { name: "Hack Squat Machine", sets: "3", reps: "10", rest: "45s", note: "Fixed path isolates quads with ~20% less spinal load than free squats." },
        { name: "Leg Extension Machine", sets: "3", reps: "12", rest: "30s", note: "Peak quad activation at full extension — 90%+ MVIC in Rectus Femoris." },
        { name: "Seated Leg Curl Machine", sets: "3", reps: "12", rest: "30s", note: "Seated stretches hamstrings more → ~11% higher activation vs. lying variant." },
        { name: "Hip Thrust Machine", sets: "3", reps: "12", rest: "45s", note: "Highest Gluteus Maximus EMG of any exercise. Pause 1s at top, full extension." },
        { name: "Calf Raise Machine", sets: "3", reps: "15", rest: "30s", note: "Full stretch at bottom, 2s hold at top. Soleus is 60% slow-twitch — needs high reps." },
      ]},
      { label: "HYROX CIRCUIT", time: "20 min · 4 rounds × 5 exercises × 1 min", exercises: [
        { name: "SkiErg", sets: "4", reps: "1 min", rest: "0s", note: "Full-body pull. Hinge at hips, drive arms explosively. The Hyrox signature cardio — trains the exact race movement." },
        { name: "Sled Push", sets: "4", reps: "1 min", rest: "0s", note: "Low body angle, drive through legs. Quads + glutes under constant tension. The most Hyrox-specific strength movement." },
        { name: "Wall Balls", sets: "4", reps: "1 min", rest: "0s", note: "Deep squat, explosive throw to 10ft target. Quads + shoulders under fatigue. Find a rhythm and hold it." },
        { name: "Rowing (1 min sprint)", sets: "4", reps: "1 min", rest: "0s", note: "Damper 5–7. Legs drive first, then lean, then pull. Rate ~28–32 spm. Full-body cardio." },
        { name: "Burpee Broad Jumps", sets: "4", reps: "1 min", rest: "0s", note: "Chest to floor → explode forward max distance. Full-body power under fatigue. Rest 30–60s between rounds if needed." },
      ]},
    ],
  },
  // ─── TUESDAY: Running Day ───
  { type: "C", name: "Running Day", focus: "Full running session — warm-up, intervals, cool-down", emoji: "🏃", color: "#059669",
    blocks: [
      { label: "WARM-UP", time: "8 min", exercises: [
        { name: "Dynamic Warm-Up", sets: "1", reps: "5 min", note: "Leg swings, high knees, butt kicks, A-skips. Prep joints and activate hip flexors + glutes for running." },
        { name: "Easy Run (Zone 2)", sets: "1", reps: "3 min", note: "Very easy pace — conversational. Gradually raise heart rate from resting to aerobic zone." },
      ]},
      { label: "MAIN RUN", time: "35 min", exercises: [
        { name: "Tempo Run (Zone 3–4)", sets: "1", reps: "15 min", note: "Comfortably hard — you can speak in short sentences. ~80–88% max HR. Builds lactate threshold." },
        { name: "Interval Sprints", sets: "6", reps: "1 min on / 1 min off", note: "1 min at 90–95% effort, 1 min jog recovery. Total 12 min. Builds VO₂max and running economy." },
        { name: "Hill Repeats", sets: "4", reps: "45s uphill / jog down", note: "Find 5–8% incline. Sprint uphill 45s, jog down. Builds glute + calf power for Hyrox running segments." },
        { name: "Easy Run (Zone 2)", sets: "1", reps: "5 min", note: "Bring heart rate back down to Zone 2. Active recovery before cool-down." },
      ]},
      { label: "COOL DOWN", time: "7 min", exercises: [
        { name: "Cool Down Jog", sets: "1", reps: "3 min", note: "Very slow jog — heart rate dropping toward resting. Flush lactic acid from muscles." },
        { name: "Stretching & Cool Down", sets: "1", reps: "4 min", note: "Hamstrings, quads, hip flexors, calves. Hold each stretch 30s. Reduces DOMS (Delayed Onset Muscle Soreness) by ~15%." },
      ]},
    ],
  },
  // ─── WEDNESDAY: Upper Machines + Hyrox ───
  { type: "D", name: "Upper + Hyrox", focus: "Upper body machines 20 min + Hyrox circuit 20 min", emoji: "🏋️", color: "#D97706",
    blocks: [
      { label: "UPPER MACHINES", time: "20 min", exercises: [
        { name: "Incline Chest Press Machine", sets: "3", reps: "10", rest: "45s", note: "30° incline hits clavicular head (upper chest). ~5–10% more upper pec activation vs. flat." },
        { name: "Assisted Pull-Up Machine", sets: "3", reps: "10", rest: "45s", note: "Lats + biceps + core. Reduce assistance over weeks — progressive overload." },
        { name: "Lateral Raise Machine", sets: "3", reps: "12", rest: "30s", note: "Medial deltoid isolation. Controlled 2s up, 3s down. Builds shoulder width." },
        { name: "Seated Row Machine", sets: "3", reps: "12", rest: "45s", note: "Close grip targets lats + lower traps. Squeeze 2s at contraction." },
        { name: "Reverse Fly Machine", sets: "2", reps: "12", rest: "30s", note: "Rear delts + rhomboids. The most neglected shoulder muscles — critical for posture." },
        { name: "Cable Bicep Curl", sets: "2", reps: "12", rest: "30s", note: "Constant cable tension through full ROM. Short head peaks ~80% MVIC." },
      ]},
      { label: "HYROX CIRCUIT", time: "20 min · 4 rounds × 5 exercises × 1 min", exercises: [
        { name: "SkiErg", sets: "4", reps: "1 min", rest: "0s", note: "Full-body pull. Hinge at hips, drive arms explosively. The Hyrox signature cardio — trains the exact race movement." },
        { name: "Sled Push", sets: "4", reps: "1 min", rest: "0s", note: "Low body angle, drive through legs. Quads + glutes under constant tension. The most Hyrox-specific strength movement." },
        { name: "Wall Balls", sets: "4", reps: "1 min", rest: "0s", note: "Deep squat, explosive throw to 10ft target. Quads + shoulders under fatigue. Find a rhythm and hold it." },
        { name: "Rowing (1 min sprint)", sets: "4", reps: "1 min", rest: "0s", note: "Damper 5–7. Legs drive first, then lean, then pull. Rate ~28–32 spm. Full-body cardio." },
        { name: "Burpee Broad Jumps", sets: "4", reps: "1 min", rest: "0s", note: "Chest to floor → explode forward max distance. Full-body power under fatigue. Rest 30–60s between rounds if needed." },
      ]},
    ],
  },
  // ─── THURSDAY: Lower Machines + Hyrox ───
  { type: "E", name: "Lower + Hyrox", focus: "Lower body machines 20 min + Hyrox circuit 20 min", emoji: "⚡", color: "#0891B2",
    blocks: [
      { label: "LOWER MACHINES", time: "20 min", exercises: [
        { name: "Smith Machine Squat", sets: "3", reps: "10", rest: "45s", note: "Feet slightly forward on Smith — reduces shear on knees. Controlled depth." },
        { name: "Lying Leg Curl Machine", sets: "3", reps: "12", rest: "30s", note: "Targets short head of biceps femoris. Squeeze at full contraction." },
        { name: "Leg Press Machine", sets: "3", reps: "12", rest: "45s", note: "Feet high + wide for glute/ham emphasis. Different angle than Monday." },
        { name: "Hip Abduction Machine", sets: "3", reps: "15", rest: "30s", note: "Glute medius — critical for hip stability and knee tracking in running + lunges." },
        { name: "Leg Extension Machine", sets: "3", reps: "12", rest: "30s", note: "Quad burnout. Go lighter, focus on the squeeze at full extension." },
        { name: "Calf Raise Machine", sets: "3", reps: "15", rest: "30s", note: "Week's second calf hit. Ankle power transfer for box jumps + running." },
      ]},
      { label: "HYROX CIRCUIT", time: "20 min · 4 rounds × 5 exercises × 1 min", exercises: [
        { name: "SkiErg", sets: "4", reps: "1 min", rest: "0s", note: "Full-body pull. Hinge at hips, drive arms explosively. End-of-week — push through the fatigue." },
        { name: "Sled Push", sets: "4", reps: "1 min", rest: "0s", note: "Legs are heavy from the week — this is race simulation. Drive low and hard." },
        { name: "Wall Balls", sets: "4", reps: "1 min", rest: "0s", note: "Deep squat, explosive throw. Embrace the quad burn. Last wall ball session of the week." },
        { name: "Rowing (1 min sprint)", sets: "4", reps: "1 min", rest: "0s", note: "Legs drive everything. Push hard through heels. Zone 4–5." },
        { name: "Burpee Broad Jumps", sets: "4", reps: "1 min", rest: "0s", note: "Full body under max fatigue. This is race day simulation. Week complete! 💪" },
      ]},
    ],
  },
];

/* ── May 2026 Schedule: Sun–Thu active, Fri–Sat off ── */
const schedule = [
  // Week 1
  { date: "Sun, May 3", week: 1, templateIdx: 0, id: 1 },
  { date: "Mon, May 4", week: 1, templateIdx: 1, id: 2 },
  { date: "Tue, May 5", week: 1, templateIdx: 2, id: 3 },
  { date: "Wed, May 6", week: 1, templateIdx: 3, id: 4 },
  { date: "Thu, May 7", week: 1, templateIdx: 4, id: 5 },
  // Week 2
  { date: "Sun, May 10", week: 2, templateIdx: 0, id: 6 },
  { date: "Mon, May 11", week: 2, templateIdx: 1, id: 7 },
  { date: "Tue, May 12", week: 2, templateIdx: 2, id: 8 },
  { date: "Wed, May 13", week: 2, templateIdx: 3, id: 9 },
  { date: "Thu, May 14", week: 2, templateIdx: 4, id: 10 },
  // Week 3
  { date: "Sun, May 17", week: 3, templateIdx: 0, id: 11 },
  { date: "Mon, May 18", week: 3, templateIdx: 1, id: 12 },
  { date: "Tue, May 19", week: 3, templateIdx: 2, id: 13 },
  { date: "Wed, May 20", week: 3, templateIdx: 3, id: 14 },
  { date: "Thu, May 21", week: 3, templateIdx: 4, id: 15 },
  // Week 4
  { date: "Sun, May 24", week: 4, templateIdx: 0, id: 16 },
  { date: "Mon, May 25", week: 4, templateIdx: 1, id: 17 },
  { date: "Tue, May 26", week: 4, templateIdx: 2, id: 18 },
  { date: "Wed, May 27", week: 4, templateIdx: 3, id: 19 },
  { date: "Thu, May 28", week: 4, templateIdx: 4, id: 20 },
];

const sessions = schedule.map(s => ({ ...s, ...templates[s.templateIdx] }));

/* ── Calendar data for May 2026 (Sun-start) ── */
const mayDays = Array.from({ length: 31 }, (_, i) => i + 1);
const firstDayOffset = 5; // May 1, 2026 = Friday; Sun-start grid offset = 5
const workoutDays = {
  3: 0, 4: 1, 5: 2, 6: 3, 7: 4,
  10: 0, 11: 1, 12: 2, 13: 3, 14: 4,
  17: 0, 18: 1, 19: 2, 20: 3, 21: 4,
  24: 0, 25: 1, 26: 2, 27: 3, 28: 4,
};
const dayLabels = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];

const tagColors = {
  "UPPER MACHINES":  { bg: "#FEE2E2", text: "#991B1B", border: "#FECACA" },
  "LOWER MACHINES":  { bg: "#E0E7FF", text: "#3730A3", border: "#C7D2FE" },
  "HYROX CIRCUIT":   { bg: "#FEF3C7", text: "#92400E", border: "#FDE68A" },
  "WARM-UP":         { bg: "#DCFCE7", text: "#166534", border: "#BBF7D0" },
  "MAIN RUN":        { bg: "#FFE4E6", text: "#9F1239", border: "#FECDD3" },
  "COOL DOWN":       { bg: "#E0F2FE", text: "#075985", border: "#BAE6FD" },
};

const TOTAL_SESSIONS = sessions.length;

function ExerciseCard({ ex, idx }) {
  const [open, setOpen] = useState(false);
  const meta = getMeta(ex.name);
  return (
    <div onClick={() => setOpen(!open)} style={{ padding: "11px 14px", background: open ? "#F8FAFC" : "#fff", borderBottom: "1px solid #F1F5F9", cursor: "pointer", transition: "background 0.15s" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <div style={{ width: 42, height: 42, borderRadius: 10, background: "#F1F5F9", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, fontSize: 20 }}>{meta.icon}</div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 4 }}>
            <div style={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 600, fontSize: 13.5, color: "#1E293B", lineHeight: 1.3 }}>
              <span style={{ color: "#94A3B8", fontWeight: 500, marginRight: 5, fontSize: 11 }}>{String(idx + 1).padStart(2, "0")}</span>
              {ex.name}
            </div>
            <span style={{ fontSize: 14, color: "#CBD5E1", transform: open ? "rotate(180deg)" : "rotate(0)", transition: "transform 0.2s", flexShrink: 0 }}>▾</span>
          </div>
          <div style={{ display: "flex", gap: 10, marginTop: 4, flexWrap: "wrap" }}>
            {ex.sets && <span style={{ fontSize: 11.5, color: "#64748B", fontFamily: "'JetBrains Mono', monospace" }}>{ex.sets} × {ex.reps}</span>}
            {ex.rest && <span style={{ fontSize: 10.5, color: "#94A3B8", fontFamily: "'JetBrains Mono', monospace" }}>rest {ex.rest}</span>}
          </div>
          <div style={{ display: "flex", gap: 4, marginTop: 5, flexWrap: "wrap" }}>
            {meta.muscles.map(m => {
              const ts = tagStyle(m);
              return <span key={m} style={{ fontSize: 9.5, fontWeight: 600, padding: "2px 7px", borderRadius: 5, background: ts.background, color: ts.color, border: `1px solid ${ts.borderColor}` }}>{m}</span>;
            })}
          </div>
        </div>
      </div>
      {open && ex.note && (
        <div style={{ marginTop: 10, marginLeft: 54, padding: "10px 12px", background: "#F1F5F9", borderRadius: 8, fontSize: 12.5, lineHeight: 1.55, color: "#475569", fontFamily: "'DM Sans', sans-serif", borderLeft: "3px solid #6366F1" }}>
          💡 {ex.note}
        </div>
      )}
    </div>
  );
}

function Calendar({ activeDay, onSelectDay }) {
  const cells = [];
  for (let i = 0; i < firstDayOffset; i++) cells.push(<div key={`e${i}`} />);
  mayDays.forEach(d => {
    const hasWorkout = workoutDays[d] !== undefined;
    const tIdx = workoutDays[d];
    const isActive = activeDay === d;
    const color = hasWorkout ? templates[tIdx].color : "transparent";
    const today = new Date().getDate() === d && new Date().getMonth() === 4; // May = 4
    cells.push(
      <div
        key={d}
        onClick={() => hasWorkout && onSelectDay(d)}
        style={{
          width: "100%", aspectRatio: "1", borderRadius: 8, display: "flex", flexDirection: "column",
          alignItems: "center", justifyContent: "center", cursor: hasWorkout ? "pointer" : "default",
          background: isActive ? color : hasWorkout ? color + "20" : "transparent",
          color: isActive ? "#fff" : hasWorkout ? color : "#94A3B8",
          fontWeight: hasWorkout ? 700 : 400, fontSize: 12, fontFamily: "'DM Sans', sans-serif",
          border: today && !isActive ? `2px solid ${color || "#6366F1"}` : isActive ? "none" : "1px solid transparent",
          transition: "all 0.15s",
        }}
      >
        {d}
        {hasWorkout && !isActive && <div style={{ width: 4, height: 4, borderRadius: 2, background: color, marginTop: 2 }} />}
        {hasWorkout && isActive && <div style={{ fontSize: 8, marginTop: 1 }}>{templates[tIdx].emoji}</div>}
      </div>
    );
  });
  return (
    <div style={{ padding: "0 20px 8px" }}>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: 4, textAlign: "center" }}>
        {dayLabels.map(d => <div key={d} style={{ fontSize: 10, color: "#94A3B8", fontWeight: 600, padding: "4px 0", fontFamily: "'DM Sans', sans-serif" }}>{d}</div>)}
        {cells}
      </div>
    </div>
  );
}

function SessionPill({ s, isActive, onClick }) {
  return (
    <div onClick={onClick} style={{
      display: "flex", alignItems: "center", gap: 8, padding: "8px 12px", borderRadius: 10, cursor: "pointer",
      background: isActive ? s.color : "#fff", color: isActive ? "#fff" : "#475569",
      border: isActive ? "none" : "1px solid #E2E8F0", transition: "all 0.15s", flexShrink: 0,
      minWidth: 0,
    }}>
      <span style={{ fontSize: 16 }}>{s.emoji}</span>
      <div style={{ minWidth: 0 }}>
        <div style={{ fontSize: 11, fontWeight: 700, fontFamily: "'DM Sans', sans-serif", whiteSpace: "nowrap" }}>{s.date}</div>
        <div style={{ fontSize: 9.5, opacity: isActive ? 0.85 : 0.6, fontFamily: "'DM Sans', sans-serif", whiteSpace: "nowrap" }}>{s.name}</div>
      </div>
    </div>
  );
}

export default function WorkoutPlan() {
  const [activeIdx, setActiveIdx] = useState(0);
  const s = sessions[activeIdx];

  const dayToIdx = {};
  sessions.forEach((sess, i) => {
    const dayNum = parseInt(sess.date.split(" ")[2]);
    dayToIdx[dayNum] = i;
  });

  const activeDay = parseInt(s.date.split(" ")[2]);

  return (
    <div style={{ minHeight: "100vh", background: "#F8FAFC", fontFamily: "'DM Sans', sans-serif", margin: "-16px -16px 0", borderRadius: 0 }}>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800&family=JetBrains+Mono:wght@400;500&display=swap" rel="stylesheet" />

      <div style={{ background: "#0F172A", padding: "24px 20px 18px", color: "#fff" }}>
        <div style={{ fontSize: 10, textTransform: "uppercase", letterSpacing: 2, color: "#94A3B8", fontWeight: 600, marginBottom: 5 }}>May 2026 Program</div>
        <h1 style={{ margin: 0, fontSize: 22, fontWeight: 800, letterSpacing: -0.5 }}>Hyrox Prep · Sun–Thu</h1>
        <div style={{ display: "flex", gap: 14, marginTop: 10, flexWrap: "wrap" }}>
          <span style={{ fontSize: 11, color: "#94A3B8" }}>🔥 {TOTAL_SESSIONS} sessions</span>
          <span style={{ fontSize: 11, color: "#94A3B8" }}>⏱ ~40–50 min each</span>
          <span style={{ fontSize: 11, color: "#94A3B8" }}>🛌 Fri/Sat OFF</span>
        </div>
        <div style={{ display: "flex", gap: 10, marginTop: 14, flexWrap: "wrap" }}>
          {templates.map(t => (
            <div key={t.type} style={{ display: "flex", alignItems: "center", gap: 4 }}>
              <div style={{ width: 8, height: 8, borderRadius: 3, background: t.color }} />
              <span style={{ fontSize: 9.5, color: "#94A3B8" }}>{t.emoji} {t.name}</span>
            </div>
          ))}
        </div>
      </div>

      <div style={{ padding: "16px 0 4px" }}>
        <div style={{ fontSize: 13, fontWeight: 700, color: "#1E293B", padding: "0 20px 8px" }}>May 2026</div>
        <Calendar activeDay={activeDay} onSelectDay={(d) => { if (dayToIdx[d] !== undefined) setActiveIdx(dayToIdx[d]); }} />
      </div>

      <div style={{ display: "flex", gap: 6, padding: "8px 16px", overflowX: "auto", WebkitOverflowScrolling: "touch" }}>
        {sessions.map((sess, i) => <SessionPill key={sess.id} s={sess} isActive={i === activeIdx} onClick={() => setActiveIdx(i)} />)}
      </div>

      <div style={{ padding: "8px 20px 10px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div style={{ width: 42, height: 42, borderRadius: 10, background: s.color, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22 }}>{s.emoji}</div>
          <div>
            <div style={{ fontSize: 11, color: "#94A3B8", fontWeight: 600 }}>{s.date} · Session {s.id}/{TOTAL_SESSIONS}</div>
            <h2 style={{ margin: 0, fontSize: 18, fontWeight: 800, color: "#1E293B" }}>{s.name}</h2>
            <p style={{ margin: "1px 0 0", fontSize: 12, color: "#64748B" }}>{s.focus}</p>
          </div>
        </div>
        {s.week >= 3 && (
          <div style={{ marginTop: 8, padding: "6px 10px", background: "#F0FDF4", borderRadius: 8, border: "1px solid #BBF7D0", fontSize: 11, color: "#166534" }}>
            📈 Week {s.week} — increase Hyrox circuit intensity: fewer rest pauses between stations, heavier sled/sandbag
          </div>
        )}
      </div>

      <div style={{ padding: "0 16px 30px" }}>
        {s.blocks.map((block, bi) => {
          const tc = tagColors[block.label] || { bg: "#F1F5F9", text: "#475569", border: "#E2E8F0" };
          return (
            <div key={bi} style={{ marginBottom: 16, borderRadius: 14, overflow: "hidden", border: "1px solid #E2E8F0", background: "#fff", boxShadow: "0 1px 3px rgba(0,0,0,0.04)" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 14px", borderBottom: "1px solid #F1F5F9" }}>
                <span style={{ fontSize: 11, fontWeight: 700, letterSpacing: 1, padding: "3px 10px", borderRadius: 6, background: tc.bg, color: tc.text, border: `1px solid ${tc.border}` }}>{block.label}</span>
                <span style={{ fontSize: 12, color: "#94A3B8", fontFamily: "'JetBrains Mono', monospace" }}>{block.time}</span>
              </div>
              {block.exercises.map((ex, ei) => <ExerciseCard key={ei} ex={ex} idx={ei} />)}
            </div>
          );
        })}
      </div>

      <div style={{ padding: "0 20px 16px" }}>
        <div style={{ padding: "14px", background: "#fff", borderRadius: 12, border: "1px solid #E2E8F0" }}>
          <div style={{ fontSize: 12, fontWeight: 700, color: "#1E293B", marginBottom: 8 }}>📊 May Progress</div>
          <div style={{ display: "flex", gap: 4, alignItems: "center" }}>
            {sessions.map((_, i) => (
              <div key={i} style={{
                flex: 1, height: 6, borderRadius: 3,
                background: i <= activeIdx ? sessions[i].color : "#E2E8F0",
                transition: "background 0.2s",
              }} />
            ))}
          </div>
          <div style={{ fontSize: 10, color: "#94A3B8", marginTop: 6, textAlign: "center" }}>
            {activeIdx + 1} of {TOTAL_SESSIONS} sessions · {((activeIdx + 1) / TOTAL_SESSIONS * 100).toFixed(0)}% complete
          </div>
        </div>
      </div>

      <div style={{ padding: "0 20px 40px", textAlign: "center" }}>
        <div style={{ padding: "16px", background: "#FFFBEB", borderRadius: 12, border: "1px solid #FDE68A" }}>
          <div style={{ fontSize: 13, fontWeight: 600, color: "#92400E", marginBottom: 4 }}>🏆 Hyrox Training Tip</div>
          <div style={{ fontSize: 12, color: "#A16207", lineHeight: 1.5 }}>Transition speed wins races. Practice moving from one station to the next with zero pause. In the circuit, treat each 1-min station as a race segment — go hard, recover on the lighter stations.</div>
        </div>
      </div>
    </div>
  );
}
